import { AnalyticsEvent } from 'src/analytics/types';

export const tabChange: AnalyticsEvent = {
  event: 'medical_certificates_tab_change',
  category: 'medical_certificates',
  action: 'tab_change',
};

export const uploadButtonClicked: AnalyticsEvent = {
  event: 'medical_certificates_upload_button_clicked',
  category: 'medical_certificates',
  action: 'upload_button_clicked',
};

export const uploadInitialized: AnalyticsEvent = {
  event: 'medical_certificates_upload_initialized',
  category: 'medical_certificates',
  action: 'upload_initialized',
};

export const uploadCancelled: AnalyticsEvent = {
  event: 'medical_certificates_upload_cancelled',
  category: 'medical_certificates',
  action: 'upload_cancelled',
};

export const uploadRetry: AnalyticsEvent = {
  event: 'medical_certificates_upload_retry',
  category: 'medical_certificates',
  action: 'upload_retry',
};

export const analysisModalOpened: AnalyticsEvent = {
  event: 'medical_certificates_analysis_modal_opened',
  category: 'medical_certificates',
  action: 'analysis_modal_opened',
};

export const fileDeleted: AnalyticsEvent = {
  event: 'medical_certificates_file_deleted',
  category: 'medical_certificates',
  action: 'file_deleted',
};

export const restoreAIData: AnalyticsEvent = {
  event: 'medical_certificates_restore_ai_data',
  category: 'medical_certificates',
  action: 'restore_ai_data',
};

export const certificateReviewed: AnalyticsEvent = {
  event: 'medical_certificates_certificate_reviewed',
  category: 'medical_certificates',
  action: 'certificate_reviewed',
};

export const certificateImageRotated: AnalyticsEvent = {
  event: 'medical_certificates_certificate_image_rotated',
  category: 'medical_certificates',
  action: 'certificate_image_rotated',
};

export const certificatesInterestModalViewed: AnalyticsEvent = {
  event: 'medical_certificates_intmodal_viewed',
  category: 'medical_certificates',
  action: 'interest_modal_viewed',
};

export const certificatesInterestModalInterested: AnalyticsEvent = {
  event: 'medical_certificates_intmodal_interested',
  category: 'medical_certificates',
  action: 'interest_modal_interested',
};

export const cpfValidationUploadByEmployee: AnalyticsEvent = {
  event: 'medical_certificates_cpf_valid',
  category: 'medical_certificates',
  action: 'cpf_valid',
};

export const forbiddenRedirectUploadByEmployee: AnalyticsEvent = {
  event: 'medical_certificates_forbidden_redirect',
  category: 'medical_certificates',
  action: 'forbidden_redirect',
};
